
import { defineComponent, ref, onMounted, onBeforeUnmount } from 'vue'
import { useForm } from 'vee-validate'

import FormEmail from '@/components/form/FormEmail.vue'
import FormPassword from '@/components/form/FormPassword.vue'
import AppButtonLogin from '@/components/buttons/AppButtonLogin.vue'
import PhoneUpdateModal from '@/components/modals/PhoneUpdateModal.vue'
import { useI18n } from 'vue-i18n'
import { loginService } from '@/services/login.service'
import { userService } from '@/services/user.service'
import { useStore } from 'vuex'
import { VuexStore } from '@/interfaces/VuexStore'
import { key } from '@/setup/store'
import { useRouter } from 'vue-router'
import useLoading from '@/composables/useLoading'
import { useToast } from 'vue-toastification'

export default defineComponent({
  components: {
    FormEmail,
    FormPassword,
    AppButtonLogin,
    PhoneUpdateModal
  },
  setup() {
    const { loading, setSearch } = useLoading(false)
    const { commit, state } = useStore<VuexStore>(key)
    const email = ref<string>('')
    const password = ref<string>('')
    const { handleSubmit } = useForm()
    const { t } = useI18n()
    const error = ref<string | null>(null)
    const router = useRouter()
    const toast = useToast()
    const showPhoneModal = ref<boolean>(false)
    let checkInterval: number | null = null

    const checkPhoneNeedsUpdate = () => {
      if (state.authUser &&
          state.authUser.email === 'david@dex360.net' &&
          (!state.authUser.telefono || state.authUser.telefono.trim() === '')) {
        showPhoneModal.value = true
      } else {
        showPhoneModal.value = false
      }
    }

    const onSubmit = handleSubmit(async () => {
      try {
        error.value = null
        setSearch(true, 'Iniciando sesión')
        const user = await loginService.ingresar(email.value, password.value)
        commit('SET_USER', user)
        toast.success('Iniciaste sesión ' + user.nombre + ' ' + user.apellido)
        setSearch(false, '')
        const url = state.returnUrl ?? { name: 'Home' }
        router.push(url)
      } catch (e: any) {
        error.value = 'Contraseña incorrecta'
        setSearch(false, '')
      }
    })

    const handlePhoneUpdate = async (telefono: string) => {
      try {
        setSearch(true, 'Actualizando teléfono')

        if (!state.authUser?.id) {
          setSearch(false, '')
          return
        }
        await userService.actualizarTelefono(telefono, state.authUser.id)
        const updatedUser = { ...state.authUser, telefono }
        commit('SET_USER', updatedUser)
        toast.success('Teléfono actualizado correctamente')
        showPhoneModal.value = false
        setSearch(false, '')

        const url = state.returnUrl ?? { name: 'Home' }
        await router.push(url)
      } catch (e: any) {
        error.value = 'Error al actualizar el teléfono'
        setSearch(false, '')
      }
    }

    onMounted(() => {
      // Verificar inmediatamente al montar
      checkPhoneNeedsUpdate()

      // Verificar cada 2 segundos mientras el componente está montado
      checkInterval = window.setInterval(checkPhoneNeedsUpdate, 2000)
    })

    onBeforeUnmount(() => {
      // Limpiar el intervalo cuando el componente se desmonta
      if (checkInterval) {
        clearInterval(checkInterval)
      }
    })

    return {
      email,
      password,
      onSubmit,
      t,
      loading,
      state,
      error,
      showPhoneModal,
      handlePhoneUpdate
    }
  }
})
